<section>
  <rappider-title-toolbar [mainTitle]="projectInformationTitle"
                          [options]="projectInformationOptiontitle"
                          [displayToolbar]="displayToolbar"
                          [displayToolbarBackButton]="displayToolbarBackButton">
  </rappider-title-toolbar>

  <section>
    <rappider-crud-fields-display [data]="activeProject"
                                  [config]="informationConfig">
    </rappider-crud-fields-display>
  </section>

  <section class="export-cards-wrapper">
    <rappider-card-icon-title-description-list [items]="exportCards"
                                               [compactCards]="true"
                                               (checkboxValueChange)="onCheckboxValueChange($event)"></rappider-card-icon-title-description-list>
    <ng-template #customTemplate let-item>
      <rappider-paragraph content="Programming Language & Framework"
                          [typography]="{fontSize:'0.9rem',fontWeight:'bold'}"></rappider-paragraph>
      <rappider-select [ngModel]="item"
                       [options]="exportCardsSelectOptions"
                       [disabled]="true"></rappider-select>
  </ng-template>
  </section>

  <rappider-project-module [activeProject]="activeProject"></rappider-project-module>
</section>
